/**
 * Vidéos clients : chargées et lues (sans son) seulement quand elles sont visibles, en pause hors écran.
 * Toucher une vidéo ou son bouton active le son (et le coupe sur les autres). Animations réduites :
 * aucune lecture automatique, toucher lance la vidéo avec le son.
 */
;(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')

  class UgcVideos extends HTMLElement {
    connectedCallback() {
      this.videos = [...this.querySelectorAll('video')]
      if (!this.videos.length) return
      this.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return
        const card = event.target.closest('.ugc__card')
        const video = card?.querySelector('video')
        if (!video || event.target.closest('a')) return
        if (event.target.closest('.ugc__sound') || event.target === video) this.toggleSound(video)
      })
      if (reducedMotion.matches || !('IntersectionObserver' in window)) return
      this.observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            const video = entry.target
            if (entry.isIntersecting) video.play().catch(() => null)
            else video.pause()
          }
        },
        { threshold: 0.6 },
      )
      for (const video of this.videos) this.observer.observe(video)
    }

    disconnectedCallback() {
      this.observer?.disconnect()
    }

    toggleSound(video) {
      const unmute = video.muted || video.paused
      for (const other of this.videos) {
        if (other === video) continue
        other.muted = true
        this.mark(other, false)
      }
      video.muted = !unmute
      if (unmute) video.play().catch(() => null)
      this.mark(video, unmute)
    }

    mark(video, soundOn) {
      const button = video.parentElement?.querySelector('.ugc__sound')
      if (!button) return
      button.setAttribute('aria-pressed', String(soundOn))
      button.setAttribute(
        'aria-label',
        (soundOn ? this.dataset.soundOff : this.dataset.soundOn) || button.ariaLabel || '',
      )
    }
  }
  if (!customElements.get('ugc-videos')) customElements.define('ugc-videos', UgcVideos)
})()
